module.exports = "//public.getcloudapp.com/packs/media/images/markers/m_2-a4df52f163e0a91b5eecdff70f43b3e9.svg";